/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createImage } from '../fn/admin-images-api/create-image';
import { CreateImage$Params } from '../fn/admin-images-api/create-image';
import { deleteImage } from '../fn/admin-images-api/delete-image';
import { DeleteImage$Params } from '../fn/admin-images-api/delete-image';
import { deleteImageThumbnails } from '../fn/admin-images-api/delete-image-thumbnails';
import { DeleteImageThumbnails$Params } from '../fn/admin-images-api/delete-image-thumbnails';
import { deleteThumbnail } from '../fn/admin-images-api/delete-thumbnail';
import { DeleteThumbnail$Params } from '../fn/admin-images-api/delete-thumbnail';
import { getAllImages } from '../fn/admin-images-api/get-all-images';
import { GetAllImages$Params } from '../fn/admin-images-api/get-all-images';
import { getImage1 } from '../fn/admin-images-api/get-image-1';
import { GetImage1$Params } from '../fn/admin-images-api/get-image-1';
import { getImageData } from '../fn/admin-images-api/get-image-data';
import { GetImageData$Params } from '../fn/admin-images-api/get-image-data';
import { getImageUsage } from '../fn/admin-images-api/get-image-usage';
import { GetImageUsage$Params } from '../fn/admin-images-api/get-image-usage';
import { getThumbnail } from '../fn/admin-images-api/get-thumbnail';
import { GetThumbnail$Params } from '../fn/admin-images-api/get-thumbnail';
import { ImageDto } from '../models/image-dto';
import { ImageUploadResponse } from '../models/image-upload-response';
import { ImageUsageDto } from '../models/image-usage-dto';
import { PageDtoImageImageDto } from '../models/page-dto-image-image-dto';
import { updateImage } from '../fn/admin-images-api/update-image';
import { UpdateImage$Params } from '../fn/admin-images-api/update-image';
import { updateImageInfo } from '../fn/admin-images-api/update-image-info';
import { UpdateImageInfo$Params } from '../fn/admin-images-api/update-image-info';

@Injectable({ providedIn: 'root' })
export class AdminImagesApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getImage1()` */
  static readonly GetImage1Path = '/api/admin/images/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImage1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage1$Response(params: GetImage1$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageDto>> {
    return getImage1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImage1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage1(params: GetImage1$Params, context?: HttpContext): Observable<ImageDto> {
    return this.getImage1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageDto>): ImageDto => r.body)
    );
  }

  /** Path part for operation `updateImage()` */
  static readonly UpdateImagePath = '/api/admin/images/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImage$Response(params: UpdateImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResponse>> {
    return updateImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImage(params: UpdateImage$Params, context?: HttpContext): Observable<ImageUploadResponse> {
    return this.updateImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageUploadResponse>): ImageUploadResponse => r.body)
    );
  }

  /** Path part for operation `deleteImage()` */
  static readonly DeleteImagePath = '/api/admin/images/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage$Response(params: DeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage(params: DeleteImage$Params, context?: HttpContext): Observable<void> {
    return this.deleteImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateImageInfo()` */
  static readonly UpdateImageInfoPath = '/api/admin/images/{id}/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImageInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImageInfo$Response(params: UpdateImageInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageDto>> {
    return updateImageInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateImageInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImageInfo(params: UpdateImageInfo$Params, context?: HttpContext): Observable<ImageDto> {
    return this.updateImageInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageDto>): ImageDto => r.body)
    );
  }

  /** Path part for operation `getAllImages()` */
  static readonly GetAllImagesPath = '/api/admin/images';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllImages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllImages$Response(params?: GetAllImages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoImageImageDto>> {
    return getAllImages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllImages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllImages(params?: GetAllImages$Params, context?: HttpContext): Observable<PageDtoImageImageDto> {
    return this.getAllImages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoImageImageDto>): PageDtoImageImageDto => r.body)
    );
  }

  /** Path part for operation `createImage()` */
  static readonly CreateImagePath = '/api/admin/images';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createImage$Response(params?: CreateImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResponse>> {
    return createImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createImage(params?: CreateImage$Params, context?: HttpContext): Observable<ImageUploadResponse> {
    return this.createImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageUploadResponse>): ImageUploadResponse => r.body)
    );
  }

  /** Path part for operation `getImageUsage()` */
  static readonly GetImageUsagePath = '/api/admin/images/{id}/usage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImageUsage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImageUsage$Response(params: GetImageUsage$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUsageDto>> {
    return getImageUsage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImageUsage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImageUsage(params: GetImageUsage$Params, context?: HttpContext): Observable<ImageUsageDto> {
    return this.getImageUsage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageUsageDto>): ImageUsageDto => r.body)
    );
  }

  /** Path part for operation `getImageData()` */
  static readonly GetImageDataPath = '/api/admin/images/{id}/image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImageData$Response(params: GetImageData$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getImageData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImageData(params: GetImageData$Params, context?: HttpContext): Observable<string> {
    return this.getImageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getThumbnail()` */
  static readonly GetThumbnailPath = '/api/admin/images/{id}/image/{size}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getThumbnail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThumbnail$Response(params: GetThumbnail$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getThumbnail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getThumbnail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThumbnail(params: GetThumbnail$Params, context?: HttpContext): Observable<string> {
    return this.getThumbnail$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `deleteImageThumbnails()` */
  static readonly DeleteImageThumbnailsPath = '/api/admin/images/{imageId}/thumbnails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteImageThumbnails()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImageThumbnails$Response(params: DeleteImageThumbnails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteImageThumbnails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteImageThumbnails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImageThumbnails(params: DeleteImageThumbnails$Params, context?: HttpContext): Observable<void> {
    return this.deleteImageThumbnails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteThumbnail()` */
  static readonly DeleteThumbnailPath = '/api/admin/images/thumbnail/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteThumbnail()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteThumbnail$Response(params: DeleteThumbnail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteThumbnail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteThumbnail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteThumbnail(params: DeleteThumbnail$Params, context?: HttpContext): Observable<void> {
    return this.deleteThumbnail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
